import type HotelFromApi from '../../../types/HotelFromApi';
import { isValidHotel } from '../isValidHotel';
import request from '../request';

type Params = {
  hotelId: string;
  locale: string;
};

const getHotelById = async ({ hotelId, locale }: Params, signal?: AbortSignal) => {
  const params: Record<string, string> = {
    locale,
    include_faqs: 'true',
    include_tags: process.env.NEXT_PUBLIC_FEATURE_FLAG_TAG_MANAGEMENT ? 'true' : 'false',
  };

  const query = new URLSearchParams(params).toString();

  const hotelFromApi = await request<HotelFromApi>({
    url: `${process.env.NEXT_PUBLIC_BFF_URL}/hotels/${encodeURI(hotelId)}?${query}`,
    method: 'GET',
    signal,
  });

  if (!isValidHotel(hotelFromApi)) {
    throw new Error('Invalid Hotel or No Hotel Matched');
  }

  return hotelFromApi;
};

export default getHotelById;
